import {
  Component, DestroyRef,
  inject,
  input,
  ChangeDetectionStrategy
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";
import { MatIcon } from "@angular/material/icon";
import { MatDialog } from "@angular/material/dialog";
import { TranslocoPipe, TranslocoService } from "@jsverse/transloco";
import { LOREN_ROUTES } from "../../../../../shared/constants/loren-routes.constants";
import { LorenAsset } from "../../../../loren-assets/interfaces/loren-asset.interface";
import { LorenPrivilegeEntityType } from "../../../../loren-roles/interfaces/loren-role.interface";
import { LorenErrorHandlingService } from "../../../../../shared/services/loren-error-handling-service/loren-error-handling-service.service";
import { LorenPageContentComponent } from "../../../../../shared/modules/loren-page-content/loren-page-content.component";
import { LorenSharedDirectivesModule } from "../../../../../shared/directives/loren-shared-directives.module";
import { LorenImageModule } from "../../../../../shared/pipes/loren-image/loren-image.module";
import { LorenSnackBarService } from "../../../../../shared/services/loren-snack-bar-service/loren-snack-bar.service";
import { LorenAssetRefresherService } from "../../../../../shared/services/loren-asset-refresher-service/loren-asset-refresher.service";
import { LorenAssetDetailsDeleteDialogComponent } from "../../loren-asset-details-delete-dialog/loren-asset-details-delete-dialog.component";
import { LorenAssetService } from "../../../../loren-assets/services/loren-asset-service/loren-asset.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MatButton } from "@angular/material/button";
import {LorenAssetType} from "../../../../loren-assets/interfaces/loren-asset-type.interface";

@Component({
  imports: [
    CommonModule,
    MatIcon,
    TranslocoPipe,
    LorenPageContentComponent,
    LorenSharedDirectivesModule,
    LorenImageModule,
    MatButton,
  ],
  selector: "loren-asset-details-base-information",
  standalone: true,
  styleUrl: "./loren-asset-details-base-information.component.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./loren-asset-details-base-information.component.html",
})
export class LorenAssetDetailsBaseInformationComponent {
  matDialog = inject(MatDialog);
  private router = inject(Router);
  private transloco = inject(TranslocoService);
  errorHandlingService = inject(LorenErrorHandlingService);
  private assetService = inject(LorenAssetService);
  private snackbarService = inject(LorenSnackBarService);
  private assetRefresherService = inject(LorenAssetRefresherService);

  private readonly destroyRef = inject(DestroyRef);
  readonly routes = LOREN_ROUTES;
  readonly writeRole = LorenPrivilegeEntityType.WRITE_ASSET;

  asset = input<LorenAsset>();
  isHandset = input<boolean>();
  groups = input.required<string[]>();
  properties = input<{ name: string; value: unknown }[]>();
  assetType = input<LorenAssetType>();
  location = input();


  editAsset() {
    this.router.navigate([LOREN_ROUTES.ASSETS_.edit(this.asset().id)]);
  }

  deleteAsset() {
    const dialogRef = this.matDialog.open(
      LorenAssetDetailsDeleteDialogComponent,
      {
        data: { assetName: this.asset().name },
        width: this.isHandset() ? "80%" : "50%",
      }
    );

    dialogRef.afterClosed().subscribe((res) => {
      if (!res) return;

      this.assetService.del(this.asset().id).pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe({
        next: () => {
          this.snackbarService.showMessage(
            this.transloco.translate("operations.successful")
          );
          this.assetRefresherService.refreshAssetData(true);
          this.router.navigateByUrl(LOREN_ROUTES.ASSETS_LIST);
        },
        error: () =>
          this.snackbarService.showMessage(
            this.transloco.translate("error_page.general_error_message")
          ),
      });
    });
  }
}
